// Cascading City -> Neighborhood select on the Schedule a Visit form.
//
// The neighborhood <select> is rendered with every neighborhood in it, each option
// tagged with the city it belongs to (see CityFilteredSelect in forms.py). It stays
// hidden until a city is picked, then shows only that city's neighborhoods.
// Rebuilding the list rather than toggling `hidden` on the options, because Safari
// ignores `hidden` on <option>.
//
// The select is disabled while it's hidden, and that matters: it's a `required`
// field, and a hidden required field the browser can't focus makes native form
// validation refuse to submit with nothing but an "invalid form control is not
// focusable" console error. oilib binds its ajax submit to the form's `submit`
// event, which never fires in that state, so the button would just go dead.
// Disabled controls are exempt from constraint validation, which avoids all of it.
//
// Everything here is applied by JS, so if this file fails to load the form still
// renders as a usable pair of full dropdowns.

const FORM_SELECTOR = "form.schedulevisitform";
const CITY_SELECTOR = "select.city";
const NEIGHBORHOOD_SELECTOR = "select.item_of_interest_id";

function initCityFilter(form) {
  const citySelect = form.querySelector(CITY_SELECTOR);
  const neighborhoodSelect = form.querySelector(NEIGHBORHOOD_SELECTOR);

  // Detail pages drop the city picker and post a hidden neighborhood instead.
  if (!citySelect || !neighborhoodSelect) {
    return;
  }

  const neighborhoodGroup = neighborhoodSelect.closest(".form-group");
  const allOptions = Array.from(neighborhoodSelect.options);
  const placeholder = allOptions.find((option) => option.value === "");

  const render = () => {
    const city = citySelect.value;
    const previous = neighborhoodSelect.value;

    neighborhoodSelect.replaceChildren();

    if (placeholder) {
      neighborhoodSelect.append(placeholder);
    }

    allOptions
      .filter((option) => option.value !== "" && option.dataset.city === city)
      .forEach((option) => neighborhoodSelect.append(option));

    // Keep the neighborhood if it survived the city change, otherwise fall back to
    // the placeholder so a stale pick can't be submitted.
    const stillOffered = Array.from(neighborhoodSelect.options).some((option) => option.value === previous);
    neighborhoodSelect.value = stillOffered ? previous : "";

    neighborhoodSelect.disabled = !city;

    if (neighborhoodGroup) {
      neighborhoodGroup.classList.toggle("d-none", !city);
    }
  };

  citySelect.addEventListener("change", render);
  render();
}

document.querySelectorAll(FORM_SELECTOR).forEach(initCityFilter);
